import MessageCourier from '../../lib/MessageCourier';
import SystemClient from '../../system/SystemClient';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { Text } from '@fluentui/react/lib/Text';
import { FederacionSelectorInput } from '../Federacion/FederacionSelector';
import { Federacion } from '../../system/Federacion/Federacion';
import React from 'react';

interface IFederationBoxNoBG {
  input: CustomInputIfc;
  system: SystemClient;
  courier: MessageCourier;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  fedId?: number | undefined;
  hideLabel?: boolean;
  onChangeExtended?: (f: Federacion) => void;
  disabled?: boolean;
  label?: string;
}

export const FederationBoxNoBG = (props: IFederationBoxNoBG) => {

  return (
    <>
      <div className="ms-Grid-col ms-sm12" style={{ padding: 0 }}>
        <div style={{ width: '100%' }}>
          <FederacionSelectorInput
            system={props.system}
            courier={props.courier}
            input={props.input}
            onBlurCustomInput={props.onBlurCustomInput}
            federacionId={props.fedId}
            hideLabel={props.hideLabel}
            onChangeExtended={props.onChangeExtended ? props.onChangeExtended : undefined}
            disabled={props.disabled}
            label={props.label}
          />
        </div>
      </div>
    </>
  );
};

export default FederationBoxNoBG;
